module.exports = __webpack_public_path__ + "img/type_document_output_icon.22889028.svg";